var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    fill: "current",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.701 3.928a8.517 8.517 0 1 1-8.509 8.517 8.556 8.556 0 0 1 8.509-8.517m0-1.594a10.111 10.111 0 1 0 0 20.222 10.111 10.111 0 0 0 0-20.222M24.222 25.892l-5.732-5.77-1.104 1.096 5.732 5.77a.78.78 0 0 0 1.27-.247.78.78 0 0 0-.166-.849"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgSearch;